import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchAllStores = async () => {
	const response =
		await cmsClient.get<CMSPaginatedData<Store>>("/store/store/");
	return response.data;
};

const useStores = () => {
	const query = useQuery(["stores"], fetchAllStores, { staleTime: 86400000 }); // 24 hours

	return query;
};

export default useStores;
